<template>
  <div class="main page-workspace home-page login-page">
    <el-row :gutter="32">
      <el-col :span="10" class="home-left-col">
        <div class="login workspace-login">
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
            <div class="title">
              <img src="../../assets/logo/byyl-logo1.png" class="logo-img">
            </div>
            <el-form-item prop="username">
              <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="请输入手机号">
                <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon"/>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                auto-complete="off"
                placeholder="请输入密码"
                @keyup.enter.native="handleLogin"
              >
                <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
              </el-input>
            </el-form-item>
            <div class="login-options">
              <el-checkbox v-model="loginForm.rememberMe" checked>记住我</el-checkbox>
              <a href="#" class="rememberPass">忘记密码</a>
            </div>
            <el-form-item style="width:100%;">
              <el-button
                :loading="loading"
                size="medium"
                type="primary"
                style="width:100%;"
                @click.native.prevent="handleLogin"
              >
                <span v-if="!loading">登 录</span>
                <span v-else>登 录 中...</span>
              </el-button>
            </el-form-item>
            <el-radio-group v-model="agree" class="login-agree">
              <el-radio @click.native.prevent="clickItem(1)" :label="1">同意隐私协议和服务条款</el-radio>
            </el-radio-group>
            <!--  底部  -->
            <div class="el-login-footer">
              <div>
                <span>帮助</span>
                <span>隐私</span>
                <span>条款</span>
              </div>
              <div>Copyright©2022 白医医疗技术部</div>
              <div style="text-align: center;">
                <b style="color:#939393;margin-top: 10px;">
                  吉ICP备2022009009号-3</b>
                <div style="display: flex;align-items: center;justify-content: center;margin-top: 5px;">
                  <img src="../../assets/images/beian.png"/>
                  <b style="color:#939393;line-height: 20px;margin-left: 3px;">
                    吉公网安备 22010202001062号</b>
                </div>
              </div>
            </div>

          </el-form>

        </div>
      </el-col>
      <el-col :span="14" class="home-right-col">
        <div class="workspace-nav login-nav">
        <el-row>
          <el-col :span="7">
            <div class="navigationDiv" @click="clickNavigation">
              <svg-icon icon-class="iconPark-classroom" class="navigationSvn"/>
              <div class="navigationTitle">我的患者</div>
            </div>
          </el-col>
          <el-col :span="7" :offset="offsetVale">
            <div class="navigationDiv" @click="clickNavigation">
              <svg-icon icon-class="stLine-cloud-upload-l" class="navigationSvn"/>
              <div class="navigationTitle">动态心电上传</div>
            </div>
          </el-col>
          <el-col :span="7" :offset="offsetVale">
            <div class="navigationDiv" @click="clickNavigation">
              <svg-icon icon-class="if-history" class="navigationSvn"/>
              <div class="navigationTitle">接诊记录</div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <div class="navigationDiv" @click="clickNavigation">
              <svg-icon icon-class="iconPark-flash-payment" class="navigationSvn"/>
              <div class="navigationTitle">极速问诊</div>
            </div>
          </el-col>
          <el-col :span="7" :offset="offsetVale">
            <div class="navigationDiv" @click="clickNavigation">
              <svg-icon icon-class="iconPark-pesticide" class="navigationSvn"/>
              <div class="navigationTitle">药械商城</div>
            </div>
          </el-col>
          <el-col :span="7" :offset="offsetVale">
            <div class="navigationDiv" @click="clickNavigation">
              <svg-icon icon-class="iconPark-preschool" class="navigationSvn"/>
              <div class="navigationTitle">健康科普</div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <div class="navigationDiv" @click="clickNavigation">
              <svg-icon icon-class="antOutline-control" class="navigationSvn"/>
              <div class="navigationTitle">慢病管理</div>
            </div>
          </el-col>
        </el-row>
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import Cookies from "js-cookie";
  import {encrypt, decrypt} from '@/utils/jsencrypt'
  import {login,getVersion,getXpVersion} from '@/api/login'
  import {getLoginUrl} from '@/api/jdRequest'
  export default {
    name: "Login",
    data() {
      return {
        offsetVale: 1,
        agree: '',
        codeUrl: "",
        cookiePassword: "",
        loginForm: {
          /*username: "18800001111",
          password: "111111",*/
          username: "",
          password: "",
          rememberMe: true,
          agree: false,
          uuid: ""
        },
        loginRules: {
          username: [
            {required: true, trigger: "blur", message: "用户名不能为空"}
          ],
          password: [
            {required: true, trigger: "blur", message: "密码不能为空"}
          ],
          code: [{required: true, trigger: "change", message: "验证码不能为空"}]
        },
        loading: false,
        redirect: undefined
      };
    },
    watch: {
      $route: {
        handler: function (route) {
          this.redirect = route.query && route.query.redirect;
        },
        immediate: true
      }
    },
    created() {
      this.getBrowseVersion();
      this.getCookie();
      /*let x = 'admin-doctor-token3';
      console.log(window.ReadCookie(x),'admin-doctor-token3');
      console.log(window.ReadCookie(x).substr(2),'admin-doctor-token3');
      let xx = new String(window.ReadCookie(x).replace(/[\r\n]/g,"").substr(2))
      console.log(xx,"xx");
      console.log(typeof xx);
      console.log(xx =='',"xx==''");
      let s1 = "abcd"
      let s2 =  "abcd";
      console.log(s1==s2,"s1==s2")*/
    },
    methods: {
      getOsVersionMethodCheck(){
        try{
          if(window.getOsVersion && typeof(getOsVersion) == "function"){
            console.log("getOsVersion存在这个方法")
            return true;
          }else{
            console.log("getOsVersion不存在这个方法")
            return false;
          }
        }catch(e){
          console.log("方法不存在");
          return false;
        }
      },
      async getXPServerVersion(AnalyzePath){
        //alert("返回值【0-参数错误；1-正确，版本号，2-系统安装错误】当前返回值="+AnalyzePath);
        // 获得软件系统版本号
        let response ;
        await getXpVersion().then(resp=>{
          console.log(resp,"version");
          response = resp;
        });
        // 开始验证是否更新
        if(response.code==0){
          let result = response.data;
          if(result.versionCode>AnalyzePath){
            console.log("..........XP浏览器需要更新............."+result.path);
            this.BeginUpdate(result.versionCode,result.path).then(function (result2) {
              console.log(result2,"111111111111111111111111111111111111");
              let state=result2.substr(0,1);            //状态，0-错误，1-正雀，2-系统安装错误
              console.log(state,"222222222222222222222222222222222222");
              let AnalyzePath=result2.substr(2);        //错误
              console.log(AnalyzePath,"333333333333333333333333333333333333");
              console.log(state,"更新状态");
            });
          }
        }
      },
      async getServerVersion(AnalyzePath){
        //alert("返回值【0-参数错误；1-正确，版本号，2-系统安装错误】当前返回值="+AnalyzePath);
        // 获得软件系统版本号
        let response ;
        await getVersion().then(resp=>{
          console.log(resp,"version");
          response = resp;
        });
        // 开始验证是否更新
        if(response.code==0){
          let result = response.data;
          if(result.versionCode>AnalyzePath){
            console.log("..........需要更新............."+result.path);
            this.BeginUpdate(result.versionCode,result.path).then(function (result2) {
              console.log(result2,"111111111111111111111111111111111111");
              let state=result2.substr(0,1);            //状态，0-错误，1-正雀，2-系统安装错误
              console.log(state,"222222222222222222222222222222222222");
              let AnalyzePath=result2.substr(2);        //错误
              console.log(AnalyzePath,"333333333333333333333333333333333333");
              console.log(state,"更新状态");
            });
          }
        }
      },
      async getBrowseVersion(){
        // 是否存在查看操作系统的方法
        let checkOsVersionMethod = this.getOsVersionMethodCheck();
        console.log("checkOsVersionMethod->",checkOsVersionMethod)
        let that = this
        if(checkOsVersionMethod){
          // 存在这个方法
          let osVersion = await this.getOsVersion(osVersion=> {    //取得浏览器版本号
            return osVersion;
          });
          console.log("操作系统版本-》osVersion->",osVersion)
          // 获得浏览器版本
          window.getVersion(function (result) {    //取得浏览器版本号
            let state=result.substr(0,1);            //状态，0-错误，1-正雀，2-系统安装错误
            let AnalyzePath=result.substr(2);        //版本号
            console.log("浏览器更新---->返回值【0-参数错误；1-正确，版本号，2-系统安装错误】当前返回值="+result);
            console.log("浏览器当前版本号：version=",AnalyzePath);
            if (osVersion == '1-WinXp' || osVersion == '1-WinVista') {
              console.log("winXp更新检测");
              that.getXPServerVersion(AnalyzePath)
            }else{
              console.log("<===================win7及其以上版本自动更新=====================>")
              console.log(AnalyzePath,"浏览器当前版本号：version");
              that.getServerVersion(AnalyzePath)
            }
          });
        }else{
          // 更新到win7版本
          // 获得浏览器版本
          window.getVersion(function (result) {    //取得浏览器版本号
            let state=result.substr(0,1);            //状态，0-错误，1-正雀，2-系统安装错误
            let AnalyzePath=result.substr(2);        //版本号
            console.log("---老版本浏览器更新----");
            console.log("浏览器当前版本号：version=",AnalyzePath);
            console.log("<===================win7及其以上版本自动更新=====================>")
            console.log(AnalyzePath,"浏览器当前版本号：version");
            that.getServerVersion(AnalyzePath)
          });
        }
      },
      clickNavigation(){
        this.msgError("请先进行登录后才能操作功能！！！");
      },
      clickItem(e) {
        e === this.agree ? this.agree = '' : this.agree = e
      },
      getCookie() {
        const username = Cookies.get("username");
        const password = Cookies.get("password");
        const rememberMe = Cookies.get('rememberMe')
        this.loginForm = {
          username: username === undefined ? this.loginForm.username : username,
          password: password === undefined ? this.loginForm.password : decrypt(password),
          rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
        };
      },
      handleLogin() {
        //1
        let that = this;
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            Cookies.set("username", this.loginForm.username, {expires: 60*24*10*365});
            //location.href="/";
            console.log(that.agree,"that.agree");
            if(that.agree==''){
              // 弹出警告框
              that.msgError("请同意隐私协议和服务条款");
              return;
            }
            this.loading = true;
            if (this.loginForm.rememberMe) {
              Cookies.set("username", this.loginForm.username, {expires: 60*24*10*365});
              Cookies.set("password", encrypt(this.loginForm.password), {expires: 60*24*10*365});
              Cookies.set('rememberMe', this.loginForm.rememberMe, {expires: 60*24*10*365});
            } else {
              Cookies.remove("username");
              Cookies.remove("password");
              Cookies.remove('rememberMe');
            }

            login(this.loginForm.username,this.loginForm.password).then(response=>{
              console.log('-------------登录返回对象--------');
              console.log("login",response);
              this.loading = false;
              if(response.code==0){
                this.loading = false;
                //auditStatus 审核状态 0 待审核 1 成功 2驳回   quickRole角色
                let resUser = response.data;
                /*Cookies.set("systemGroup","医生端");
                Cookies.set("id",resUser.userId);*/
                // this.setToken(resUser.token,{expires: 60*24*10*365});

                this.setToken(resUser.token);
                let {token,refreshToken,expireTtl} = resUser;
                let refreshTokenObject = {token,refreshToken,expireTtl}
                console.log("refreshTokenObject---->",refreshTokenObject);
                this.setJsonObjectToLocal(window.sessionStorage,this.$CONSTANT.REFRESH_TOKEN,refreshTokenObject);
                // 临时存储 用户代理身份
                localStorage.setItem("isSubstitution",resUser.isSubstitution)
                sessionStorage.setItem("doctorType",resUser.doctorType) //0医生 1非出诊医生 2药师 3药店店员 4业务员 5护士
                sessionStorage.setItem("proxyFlag",resUser.proxyFlag)
                localStorage.setItem("xy-doctor-userId",resUser.userId);
                localStorage.setItem("xy-organization-Id",resUser.organizationId);
                localStorage.setItem("xy-doctor-phone",this.loginForm.username);
                location.href="/";
                // this.jdRequestCode()
              }
            }).catch(() => {
              this.loading = false;
            });
          }
        });
      },
      // jdRequestCode(){
      //   getLoginUrl().then(response=>{
      //     console.log("response",response)
      //     if(response.code==0){
      //       // location.href="/";
      //       // this.$router.push('/callback');
      //       window.location.href = response.data.url;
      //     }
      //   })
      // },
    }
  };
</script>

<style>
  .login {
    display: flex;
    justify-content: center;
    align-items: stretch;
    height: 100%;
    width: 100%;
  }

  .login-form .input-icon {
    height: 10px;
    width: 5px;
    margin-left: 2px;
  }

  .login-form .el-input {
    height: 40px;
  }

  .login-form .el-input input {
    height: 40px;
  }

  .login-options {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 16px;
  }

  .login-agree {
    margin: 0 0 4px;
    width: 100%;
  }

  .el-login-footer {
    height: auto;
    width: 100%;
    text-align: center;
    font-size: 12px;
    margin-top: 12px !important;
  }

  .el-login-footer div {
    padding-bottom: 6px;
  }

  .el-login-footer div span {
    margin-right: 20px;
  }

  .rememberPass {
    font-size: 14px;
    float: none;
    color: #1a7fbf;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/login.vue